export const DATA_VALUE_FIELDS = {
  DISABLED: 'disabled',
  ERROR: 'error',
  HIDDEN: 'hidden',
  VALUE: 'value',
};

export const DEFAULT_DATA_VALUE = {
  [DATA_VALUE_FIELDS.DISABLED]: false,
  [DATA_VALUE_FIELDS.ERROR]: '',
  [DATA_VALUE_FIELDS.HIDDEN]: false,
  [DATA_VALUE_FIELDS.VALUE]: '',
};

export const DATA_FIELDS = {
  MARK_AS_PTS: 'markAsPTS',
  MODEL_AS_PTS: 'modelAsPTS',
  TYPE_OF_USE: 'typeOfUse',
};

export const TYPE_OF_USE_VALUES = {
  /** В иных коммерческих целях */
  COMMERCIAL: 'commercial',
  /** Личное использование */
  PERSONAL: 'personal',
  TAXI: 'taxi',
};
